import axios from "axios";
import _ from "lodash";

export default {
    data() {
        return {
            isCollective: false,
            selected: [],
            sppd: [],
            EnCommission: false,
            Viwithout_note: true,
            loadingSet: false,
            loadingCollective: false,
            loadingSetDone: false
        }
    },
    beforeCreate() {
        this.formCollective = this.$form.createForm(this);
    },
    activated(){
        this.fetchDetail();
    },
    watch: {
        collectData() {
            // this.isCollective = true;
            this.fetchDetail();
        }
    },
    methods: {
        onCollective() {
            this.loadingCollective = true
            this.fetchDetail().then(()=>{
                // this.EnCommission = true;
                this.Viwithout_note = true;
                this.$nextTick(function () {
                    this.formCollective.setFieldsValue({
                        iscommision: "1",
                        without_note: "0",
                    });
                });
                this.isCollective = true;
                this.loadingCollective = false
            })
        },
        async handleCloseCollective() {
            this.loadingSetDone = true
            await this.fetchDetail()
            this.loadingSetDone = false
            this.isCollective = false;
        },
        handleCheck(e) {
            const item = {
                id_klaim: e.target.value.id_klaim_draft,
                id: e.target.value.id,
                kredit: e.target.value.kredit
            };
            this.selected.filter(obj => obj.id == item.id).length == 0 ? this.selected.push(item) : this.selected.splice(this.selected.findIndex(obj => obj.id == item.id), 1)
        },
        filterOption(input, option) {
            return (
                option.componentOptions.children[0].children[0].elm.innerText
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
            );
        },
        handleSppd(e) {
            this.selectedSppd = this.sppd.filter(
                (obj) => obj.id_sppd_dtl.toLowerCase().indexOf(e.toLowerCase()) >= 0
            );

            let selectedumDtl = _.filter(this.sppd, { id_sppd_dtl: e });
            //console.log(selectedumDtl)
            if(selectedumDtl[0] && selectedumDtl[0].is_komisi){
                // this.EnCommission = true;
                this.Viwithout_note = false;
                this.$nextTick(function () {
                this.formCollective.setFieldsValue({
                    iscommision: "1",
                    without_note: "0",
                });
                });
            }else{
                // this.EnCommission = false;
                this.Viwithout_note = true;
                this.$nextTick(function () {
                this.formCollective.setFieldsValue({
                    iscommision: "0",
                    without_note: "0",
                });
                });
            }
        },
        async fetchDetail() {
            await axios({
                method: "get",
                url: this.$serviceUrl + "klaim_cc_pd/sppd_detil",
                params: {
                    id_sppd: this.collectData.informasi.id_sppd,
                    id_klaim_draft: this.id_klaim,
                },
                auth: {
                    username: this.getAuth.username,
                    password: this.getAuth.password,
                },
                headers: {
                    "X-API-KEY": this.getAuth.apikey,
                },
            })
                .then((response) => {
                    this.sppd = response.data.list_nama_item;
                })
                .catch((err) => {
                    alert(err);
                    // this.displayMessage("error-getdetil");
                });
        },
        handleSet() {
            this.formCollective.validateFields((err, values) => {
                if (err) {
                    this.displayMessage("form-warning");
                    return;
                }

                this.loadingSet = true
                axios({
                    method: "put",
                    url: this.type == 'revised' ? this.$serviceUrl + "klaim_cc_pd/revisi_detil_pemakaian_kolektif" : this.$serviceUrl + "klaim_cc_pd/detil_pemakaian_kolektif",
                    processData: false,
                    data: {
                        "id_klaim": this.id_klaim,
                        "id_sppd_dtl": values.id_sppd_dtl,
                        "selected_item": this.selected,
                        "iscommision": values.iscommision,
                        "without_note": "1"
                    },
                    auth: {
                        username: this.getAuth.username,
                        password: this.getAuth.password,
                    },
                    headers: {
                        "Content-Type": "application/json",
                        "X-API-KEY": this.getAuth.apikey,
                    },
                }).then(async () => {
                    await this.fetchPemakaian();
                    await this.fetchDetail()
                    this.displayMessage("success-save")
                    this.formCollective.resetFields();
                    // this.EnCommission = true;
                    this.Viwithout_note = true;
                    this.$nextTick(function () {
                        this.formCollective.setFieldsValue({
                            iscommision: "1",
                            without_note: "0",
                        });
                    });
                    this.selected = [];
                    this.loadingSet = false
                }).catch(err => {
                    this.displayMessageValue("basic-error", err.response.data.message)
                })
            })
        },
        handleChangeumDtl(val){
            let selectedumDtl = _.filter(this.list, { id_um_dtl: val });
            //console.log(selectedumDtl)
            if(selectedumDtl[0] && selectedumDtl[0].is_komisi){
                // this.EnCommission = true;
                this.Viwithout_note = false;
                this.$nextTick(function () {
                this.formCollective.setFieldsValue({
                    iscommision: "1",
                    without_note: "0",
                });
                });
            }else{
                // this.EnCommission = false;
                this.Viwithout_note = true;
                this.$nextTick(function () {
                this.formCollective.setFieldsValue({
                    iscommision: "0",
                    without_note: "0",
                });
                });
            }
        },
    }
}